import { useAtomValue } from 'jotai';
import { Typography } from '@statsbomb/kitbag-components';
import { unwrappedPlayerInfoAtom } from '@/atoms/player/info';

export const PlayerPreviewTitle = () => {
  const playerInfo = useAtomValue(unwrappedPlayerInfoAtom);

  return (
    <Typography as="span" variant="headingLarge" data-testid="player-preview-player-name" className="opacity-80">
      {playerInfo?.displayName || ''}
    </Typography>
  );
};
